export enum EmailEventSource {
    MAILOPS = 'mailops',
    SENDGRID = 'sendgrid',
}